var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"svv-fade-transition"}},[(_vm.widgetNotice.open)?_c('div',{class:[
      'svv-wgt-notice',
      _vm.widgetNotice.status === 0 ? 'success' : 'error',
    ]},[_c('div',{staticClass:"svv-wgt-notice-inner"},[_vm._v(_vm._s(_vm.widgetNotice.message))])]):_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }